import { render, staticRenderFns } from "./AlbumEditDetail.vue?vue&type=template&id=0010760e&scoped=true"
import script from "./AlbumEditDetail.vue?vue&type=script&lang=js"
export * from "./AlbumEditDetail.vue?vue&type=script&lang=js"
import style0 from "./AlbumEditDetail.vue?vue&type=style&index=0&id=0010760e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010760e",
  null
  
)

export default component.exports